import React from 'react';
import { LazySection } from './LazySection';
export function Costo() {
  return <LazySection className="bg-ink text-cream !py-[80px] md:!py-[100px]" data-id="element-100">
      <div className="container-wide" data-id="element-101">
        <div className="text-center mb-[50px]" data-id="element-102">
          <h2 className="text-[clamp(30px,4.5vw,44px)] mb-3.5 text-cream" data-id="element-103">
            ⚖️ ¿Cuánto cuesta <em className="text-gold-light" data-id="element-104">no tenerlo</em>?
          </h2>
          <p className="text-cream/70 text-[16px] max-w-[620px] mx-auto" data-id="element-105">
            El precio real no es lo que pagás hoy,{' '}
            <strong data-id="element-106">es lo que te sigue costando no hacerlo</strong>.
          </p>
        </div>

        <div className="max-w-[820px] mx-auto bg-white/5 rounded-[16px] overflow-hidden border border-cream/10" data-id="element-107">
          <div className="grid grid-cols-1 md:grid-cols-2 bg-white/5 border-b border-cream/10" data-id="element-108">
            <div className="p-4 md:px-6 md:py-4 font-serif text-[15px] font-medium text-red-x hidden md:block" data-id="element-109">
              Sin entender el origen
            </div>
            <div className="p-4 md:px-6 md:py-4 font-serif text-[15px] font-medium text-gold-light hidden md:block" data-id="element-110">
              Costo real
            </div>
          </div>

          {[{
          bad: 'Otro año de terapia trabajando el síntoma',
          real: '$240.000+ en sesiones sin llegar a la raíz'
        }, {
          bad: 'Otra relación repitiendo el mismo patrón',
          real: 'Energía, años y confianza que no vuelven'
        }, {
          bad: 'Seguir cargando lo que no es tuyo',
          real: 'Ansiedad crónica · insomnio · cuerpo agotado'
        }, {
          bad: 'Transmitirles a tus hijos lo que heredaste',
          real: 'Ver en ellos lo que ya reconocés en vos'
        }, {
          bad: 'Otro domingo con la sensación de "¿cuándo va a cambiar?"',
          real: 'El mismo ciclo · el próximo año'
        }].map((row, i) => <div key={i} className="grid grid-cols-1 md:grid-cols-2 border-b border-cream/10 last:border-0" data-id="element-111">
              <div className="p-4 md:px-6 md:py-[18px] text-[14px] leading-[1.5] text-cream/65 italic md:border-r border-cream/10 border-b border-black/20 md:border-b-0" data-id="element-112">
                <span className="md:hidden font-semibold not-italic text-red-x mr-2" data-id="element-113">
                  Sin entenderlo:
                </span>{' '}
                {row.bad}
              </div>
              <div className="p-4 md:px-6 md:py-[18px] text-[14px] leading-[1.5] text-cream font-medium" data-id="element-114">
                <span className="md:hidden font-semibold text-gold-light mr-2" data-id="element-115">
                  Costo real:
                </span>{' '}
                {row.real}
              </div>
            </div>)}
        </div>
      </div>
    </LazySection>;
}